import './comments-items.scss';

//library
import { useQuery } from '@apollo/client';
import format from 'date-fns/format';
import InfiniteScroll from "react-infinite-scroll-component";
//shared
import { DataNotFound } from '../data-not-found/data-not-found';
import { DATA_NOT_FOUND } from './constants/DataNotFound';
import { SkeletonComments } from '../skeleton-comments/skeleton-comments';
import { BRANCH_COMMENTS, CLASS_TYPES } from '../../graphql/branch';
import CircularProgress from '@mui/material/CircularProgress';

import { SELECT_DATA } from './constants/select';

//material
import Grid from '@mui/material/Grid';
import Rating from '@mui/material/Rating';
import { useEffect, useMemo, useState } from 'react';
import { Star } from '@mui/icons-material';
import { Box } from '@mui/material';
import { SelectMui } from '../select/select';

let comments: any = [];
let page: number = 1

export const CommentsItems = ({ branchId }: { branchId: number }) => {

    const [activeFilter, setActiveFilter] = useState<any>(null);
    const [average, setAverage] = useState<number | null>(null);
    const [initialAverage, setInitialAverage] = useState<any>(null);
    const [selectedCommentType, setSelectedCommentType] = useState<any>(null);

    const { data: dataTypeClass, error: errorTypeClass } = useQuery(CLASS_TYPES,{
        variables: {isByRating: true, idBranch: branchId}
    });
    if (errorTypeClass) console.log(`Submission error! ${errorTypeClass.message}`);

    let dataTypeClassData: any = [];
    if (dataTypeClass && dataTypeClass.classTypes && dataTypeClass.classTypes.data) {
        dataTypeClassData = dataTypeClass.classTypes.data;
        SELECT_DATA.items = dataTypeClassData;
        // SELECT_DATA.value = '';
    }

    let [filters] = useState({
        idBranch: branchId,
        page: comments.page,
        perPage: 10,
        idClassType: ''
    });
    filters.idBranch = branchId;
    comments = [];

    //Query
    const { loading, error, data, fetchMore } = useQuery(BRANCH_COMMENTS, {
        variables: filters,
    });
    //if (data && !data.newComments.data.length) return <DataNotFound data={DATA_NOT_FOUND} />;
    if (error) console.log(`Submission error! ${error.message}`);
    if (data) {
        comments = data.newComments;
        page = data.newComments.current_page;
    }

    const fetchMoreData = () => {
        fetchMore({
            variables: { ...filters, page: page + 1 }, updateQuery: (previousQueryResult: any, { fetchMoreResult }: any) => {
                fetchMoreResult.newComments.data = [
                    ...previousQueryResult.newComments.data,
                    ...fetchMoreResult.newComments.data,
                ];
                return fetchMoreResult;
            }
        });
    };

    const filterComments = (id: any) => {
        filters.idClassType = String(id);

        fetchMore({
            variables: filters,
        }).then((result: any) => {

            fetchMore({
                variables: { ...filters, page: 1 },
                updateQuery: (previousQueryResult: any, { fetchMoreResult }: any) => {
                    fetchMoreResult.newComments.data = [
                        ...fetchMoreResult.newComments.data,
                    ];
                    return fetchMoreResult;
                }
            });
        }
        ).catch((error: any) => {
            console.error(error)
        }).finally(() => {

            setTimeout(() => {
                // Calcula el nuevo promedio y actualiza initialAverage y average
                const totalSum = comments.data?.reduce((accumulator: any, currentValue: any) => accumulator + currentValue.total, 0);
                const newAverage: any = totalSum / comments.data.length;
                setAverage(newAverage.toFixed(1));
            }, 500);
        });

    }

    /* seEffect(() => {
        if (comments && comments.data && comments.data?.length > 0 && initialAverage === null) {
            const totalSum = comments.data.reduce((accumulator: any, currentValue: any) => accumulator + currentValue.total, 0);
            const newAverage: any = totalSum / comments.data.length;
            setInitialAverage({ length: comments.data.length, average: newAverage.toFixed(1) });
            setAverage(newAverage.toFixed(1));
        }
    }, [comments, initialAverage]); */

    const calculatedAverage = useMemo(() => {
        if (comments && comments.data && comments.data.length > 0) {
            const totalSum = comments.data.reduce((accumulator: any, currentValue: any) => accumulator + currentValue.total, 0);
            const newAverage = totalSum / comments.data.length;
            return newAverage.toFixed(1);
        }
        return null;
    }, [comments]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (calculatedAverage !== null && initialAverage === null) {
            setInitialAverage({ length: comments.data.length, average: calculatedAverage });
            setAverage(Number(calculatedAverage));
        }
    }, [calculatedAverage, initialAverage]);

    const filterByType = (type: string) => {
        let element = dataTypeClassData.filter((el: any) => el.name === type)[0];
        filterComments(element.id);
        setActiveFilter(element.id);

        setSelectedCommentType(element.id);
    }

    return (
        <div className='container-comments'>

            {dataTypeClassData.length > 0 && (
                <div className='section-filters-score'>
                    {/* {                   
                        dataTypeClassData.map((element: any) => (
                            <span
                                className={`badge-type-class cursor-pointer mb-05 ${element.id === activeFilter ? 'active-badge' : ''}`}
                                onClick={() => {
                                    filterComments(element.id);
                                    setActiveFilter(element.id);
                                }}
                                key={element.id}
                            >
                                {element.name}
                            </span>
                        ))
                    } */}

                    <SelectMui
                        selectData={{
                            value: selectedCommentType,
                            items: SELECT_DATA.items,
                            size: 'large',
                            textLabel: 'Continuar',
                            id: 'comments',
                            label: false,
                        }}
                        keySelect={'classTypeComments'} placeholder='Seleccionar clase' onAction={(newValueClassType: any) => { filterComments(newValueClassType); setActiveFilter(newValueClassType) }}></SelectMui>
                </div>
            )}

            {(loading) && (
                <SkeletonComments></SkeletonComments>
            )}
            {((Object.entries(comments).length === 0) || (data.newComments.total === 0)) && (

                <DataNotFound data={DATA_NOT_FOUND} />
            )}
            {(Object.entries(comments).length > 0) && (
                <InfiniteScroll
                    dataLength={comments.data.length}
                    next={fetchMoreData}
                    hasMore={data.newComments.has_more_pages}
                    loader={<p style={{ textAlign: 'center' }}>
                        <CircularProgress size={25} />
                    </p>}
                >

                    {(Object.entries(comments.data).length > 0) && (
                        <Grid container className='container-average' justifyContent={'center'}>
                            <Grid item margin={'10px auto'}>
                                <h4 className='title-average'>General</h4>
                                <Box sx={{ display: 'inline-flex' }} className='average-section'>
                                    <div className='general'>
                                        <Star style={{ fontSize: 40 }}></Star>
                                        <span>{initialAverage?.average}</span>
                                    </div>
                                    <span className='count-rating ml-05'>
                                        ({`${initialAverage?.length} ${initialAverage?.length === 1 ? 'calificación' : 'calificaciones'}`})
                                    </span>
                                </Box>
                            </Grid>

                            {activeFilter && (
                                <Grid item margin={'10px auto'}>
                                    <h4 className='title-average'>{dataTypeClassData.filter((el: any) => el.id === activeFilter)[0]?.name}</h4>
                                    <Box sx={{ display: 'inline-flex' }} className='average-section specific-average'>
                                        <div className='general'>
                                            <Star style={{ fontSize: 40 }}></Star>
                                            <span>{average}</span>
                                        </div>
                                        <span className='count-rating ml-05'>
                                            ({`${comments.data.length} ${comments.data.length === 1 ? 'calificación' : 'calificaciones'}`})
                                        </span>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    )}



                    {comments.data.map((comment: any) => (
                        <div className='card-comment' key={comment.id}>
                            <p>{comment.comments}</p>

                            <Grid container className='info-comment'>
                                <Grid item xs={6} sx={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <div className='badge-type-class' onClick={() => { filterByType(comment.classType) }}>
                                        {comment.classType}
                                    </div>
                                    <div className='info-hour'>
                                        {format(new Date(comment.created), "dd/M/yyyy")}
                                        <span>&nbsp;|&nbsp;</span>
                                        {format(new Date(comment.created), "HH:mm")}
                                    </div>
                                </Grid>
                                <Grid item xs={6} className='rating-contain'>
                                    <Rating sx={{ color: 'orange !important' }} name="read-only" value={comment.total} readOnly />
                                </Grid>
                            </Grid>
                        </div>
                    ))}
                </InfiniteScroll>
            )}
        </div>
    );
}